/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_Reading_EvidenceInputs */

const en_us2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking the evidence…`)
};

const pt_br2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando as evidências…`)
};

const es_419_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisando la evidencia…`)
};

const pt_pt2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A consultar as evidências…`)
};

const fr_fr2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification des données scientifiques…`)
};

const de_de2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe die Studienlage…`)
};

const it_it2_coach_extra_activity_reading_evidence = /** @type {(inputs: Coach_Extra_Activity_Reading_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulto le evidenze…`)
};

/**
* | output |
* | --- |
* | "Checking the evidence…" |
*
* @param {Coach_Extra_Activity_Reading_EvidenceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_reading_evidence = /** @type {((inputs?: Coach_Extra_Activity_Reading_EvidenceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_Reading_EvidenceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_reading_evidence(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_reading_evidence(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_reading_evidence(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_reading_evidence(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_reading_evidence(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_reading_evidence(inputs)
	return en_us2_coach_extra_activity_reading_evidence(inputs)
});
export { coach_extra_activity_reading_evidence as "coach-extra.activity_reading_evidence" }